define('touchHelper',[], () => {
  'use strict';

  /**
     *
     * Run a callback after a click or tap, without running duplicate callbacks for the same event.
     *
     * @private
     * @param  {Function} callback The callback function to run on a click or tap event.
     */
  function onClickOrTap(callback) {
    if (!callback || typeof (callback) !== 'function') {
      return;
    }

    if (typeof this.addEventListener !== 'function') {
      return;
    }

    let startX = 0;
    let startY = 0;
    let distX = 0;
    let distY = 0;

    /**
         * touchend event handler
         * @param  {event} event The touchend event
         */
    const onTouchEndEvent = function (event) {
      distX = event.changedTouches[0].pageX - startX;
      distY = event.changedTouches[0].pageY - startY;

      if (Math.abs(distX) >= 7 || Math.abs(distY) >= 10) {
        return;
      }

      callback(event);

      if (event.cancelable) {
        event.target.removeEventListener('click', callback);
      }
    };

    /**
         * touchend event handler
         * @param  {event} event The touchstart event
         */
    const onTouchStartEvent = function (event) {
      startX = event.changedTouches[0].pageX;
      startY = event.changedTouches[0].pageY;
    };

    // Event listeners
    this.addEventListener('touchstart', onTouchStartEvent, { passive: true });
    this.addEventListener('touchend', onTouchEndEvent, false);
    this.addEventListener('click', callback, false);
  }

  function dispatchClickOrTab(event) {
    if (event.type === 'touchend') {
      const touchstart = new TouchEvent('touchstart', {
        changedTouches: event.changedTouches
      });
      this.dispatchEvent(touchstart);

      const touchend = new TouchEvent('touchend', {
        changedTouches: event.changedTouches
      });
      this.dispatchEvent(touchend);
      return;
    }

    this.dispatchEvent(new Event('click'));
  }

  Element.prototype.onClickOrTap = onClickOrTap;
  Document.prototype.onClickOrTap = onClickOrTap;
  Element.prototype.dispatchClickOrTab = dispatchClickOrTab;
});

